import { TextField, Grid } from '@material-ui/core';
import { useFormContext, Controller } from 'react-hook-form';

const CustomTextField = ({ name, label }) => {
	const { control } = useFormContext();

	return (
		<Grid item xs={12} sm={6}>
			<Controller
				defaultValue=""
				control={control}
				name={name}
				render={({ field: { onChange, value } }) => (
					<TextField
						label={label}
						fullWidth
						value={value}
						onChange={onChange}
						required
					/>
				)}
			/>
		</Grid>
	);
};

export default CustomTextField;
